import CryptoJs from 'crypto-js'
import encHex from 'crypto-js/enc-hex'
let requestId = ''// 用来保存requestIdleCallback返回的id
export const sliceUpload = {
  dialogFormVisible: true, // 退出时候中断计算的标记
  createFileChunk (file, size) {
    const sliceCount = Math.ceil(file.size / size)
    const chunks = []
    for (let i = 0; i < sliceCount; ++i) {
      // 计算分片起始位置
      const start = i * size
      // 计算分片结束位置
      let end = start + size
      // 最后一片特殊处理
      if (end > file.size) {
        end = file.size
      }
      const chunk = file.slice(start, end)
      chunks.push({ index: start, file: chunk })
    }
    return chunks
  },
  // 整个文件计算量太大可能造成浏览器卡顿，抽样计算计算减少计算量
  async calculateHashSample (file, hashProgress, signMethod) {
    let endTime
    const beginTime = new Date().getTime()
    console.log('上传准备开始：', beginTime)
    // 布隆过滤器  判断一个数据存在与否
    // 1个G的文件，抽样后5M以内
    // hash一样，文件不一定一样
    // hash不一样，文件一定不一样
    return new Promise(resolve => {
      // 创建用于计算的对象
      /* let algo
      algo = CryptoJs.algo.MD5.create()
      if (signMethod.toString() === '0') {
        algo = CryptoJs.algo.MD5.create()
      } else {
        algo = CryptoJs.algo.SHA256.create()
      } */
      const algo = CryptoJs.algo.MD5.create() // 改为都由MD5计算
      // const reader = new FileReader()

      const size = file.size
      const offset = 2 * 1024 * 1024
      // 第一个2M，最后一个区块数据全要
      const chunks = [file.slice(0, offset)]

      let cur = offset
      while (cur < size) {
        if (cur + offset >= size) {
          // 最后一个区快(取全部)
          chunks.push(file.slice(cur, cur + offset))
        } else {
          // 中间的区块
          const mid = cur + offset / 2
          const end = cur + offset
          // 所有中间区块，抽取头 中 尾各两个字节
          chunks.push(file.slice(cur, cur + 2))
          chunks.push(file.slice(mid, mid + 2))
          chunks.push(file.slice(end - 2, end))
        }
        cur += offset
      }
      let count = 0

      const start = async () => {
        const reader = new FileReader()
        reader.onload = async (e) => {
          const wordArray = CryptoJs.lib.WordArray.create(e.target.result)
          // console.log('计算完：', count)
          await algo.update(wordArray)
          count++
          if (count < chunks.length) {
            hashProgress.uploadSuccess = Number(
              ((100 * count * 0.3) / chunks.length).toFixed(1)
            )
            if (this.dialogFormVisible) {
              start()
            } else {
              resolve(false)
            }
          } else {
            endTime = new Date().getTime()
            console.log('上传准备结束：', endTime)
            console.log('上传准备耗时：', (endTime - beginTime) / 1000, '秒')
            hashProgress.uploadSuccess = 30
            resolve(encHex.stringify(algo.finalize()))
          }
          // resolve()
        }
        reader.readAsArrayBuffer(new Blob([chunks[count].file]))
      }

      start()

      // 中间的，取前中后各2各字节
      // reader.readAsArrayBuffer(new Blob(chunks))
      // reader.onload = e => {
      //   const wordArray = CryptoJs.lib.WordArray.create(e.target.result)
      //   algo.update(wordArray)
      //   hashProgress.uploadSuccess = 30
      //   resolve(encHex.stringify(algo.finalize()))
      // }
    })
  },
  // 60fps
  // 1秒渲染60次 渲染1次 1帧，大概16.6ms
  // |帧(system task，render，script)空闲时间  |帧 painting idle   |帧   |帧   |
  // 借鉴fiber架构(利用requestIdleCallback浏览器的空闲时间来做hash计算，不会导致卡顿，但是有些浏览器不支持)
  async calculateHashIdle (chunks, hashProgress, signMethod) {
    let endTime
    const beginTime = new Date().getTime()
    console.log('上传准备开始：', beginTime)
    // 先取消上一个requestIdleCallback
    if (requestId) {
      window.cancelIdleCallback(requestId)
    }
    // 将所有切片过来，循环计算出
    return new Promise((resolve) => {
      const algo = CryptoJs.algo.MD5.create()
      /* let algo
      if (signMethod.toString() === '0') {
        algo = CryptoJs.algo.MD5.create()
      } else {
        algo = CryptoJs.algo.SHA256.create()
      } */
      let count = 0
      const appendToSpark = async (file) => {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.readAsArrayBuffer(file)
          reader.onload = (e) => {
            const wordArray = CryptoJs.lib.WordArray.create(e.target.result)
            algo.update(wordArray)
            resolve()
          }
        })
      }
      const workLoop = async (deadline) => {
        // timeRemaining获取当前帧的剩余时间
        while (count < chunks.length && deadline.timeRemaining() > 1) {
          if (this.dialogFormVisible) {
            // console.log('计算：', count)
            // 空闲时间，且有任务
            await appendToSpark(new Blob([chunks[count].file]))
            count++
            if (count < chunks.length) {
              hashProgress.uploadSuccess = Number(
                ((100 * count * 0.3) / chunks.length).toFixed(1)
              )
            } else {
              endTime = new Date().getTime()
              console.log('上传准备结束：', endTime)
              console.log('上传准备耗时：', (endTime - beginTime) / 1000, '秒')
              hashProgress.uploadSuccess = 30
              resolve(encHex.stringify(algo.finalize()))
              // resolve(spark.end())
            }
          } else {
            resolve(false)
          }
        }
        requestId = window.requestIdleCallback(workLoop)
      }
      // 浏览器一旦空闲，就会调用workLoop
      requestId = window.requestIdleCallback(workLoop)
    })
  },
  // 整个文件直接暴力循环计算
  async calculateHashLoop (chunks, hashProgress, signMethod) {
    let endTime
    const beginTime = new Date().getTime()
    console.log('上传准备开始：', beginTime)
    // 布隆过滤器  判断一个数据存在与否
    // 1个G的文件，抽样后5M以内
    // hash一样，文件不一定一样
    // hash不一样，文件一定不一样
    return new Promise(resolve => {
      // 创建用于计算的对象
      const algo = CryptoJs.algo.MD5.create()
      /* let algo
      if (signMethod.toString() === '0') {
        algo = CryptoJs.algo.MD5.create()
      } else {
        algo = CryptoJs.algo.SHA256.create()
      } */
      let count = 0
      const start = async () => {
        const reader = new FileReader()
        reader.onload = async (e) => {
          const wordArray = CryptoJs.lib.WordArray.create(e.target.result)
          // console.log('计算完：', count)
          await algo.update(wordArray)
          count++
          if (count < chunks.length) {
            hashProgress.uploadSuccess = Number(
              ((100 * count * 0.3) / chunks.length).toFixed(1)
            )
            // 窗口还是保持打开的情况下，继续计算
            if (this.dialogFormVisible) {
              start()
            } else {
              resolve(false)
            }
          } else {
            endTime = new Date().getTime()
            console.log('上传准备结束：', endTime)
            console.log('上传准备耗时：', (endTime - beginTime) / 1000, '秒')
            hashProgress.uploadSuccess = 30
            resolve(encHex.stringify(algo.finalize()))
          }
          // resolve()
        }
        reader.readAsArrayBuffer(new Blob([chunks[count].file]))
      }
      start()
    })
  }
}
